import React from "react";

export const DebugContext = React.createContext({
  showJson: false,

  // eslint-disable-next-line @typescript-eslint/no-empty-function --- _value is required to implement the useContext interface
  setShowJson: (_value: boolean) => {},
});
